import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { CAMPO } from "../../../../components/ui/Filter/sizes";
import { PeriodFilter } from "../../../../components/ui/Form/PeriodFilter";
import { Select } from "../../../../components/ui/Form/Select";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { CRM_PET_RULES, DIAGNOSIS_RULE_OPTIONS, PERIOD_OPTIONS, RECOVERY_STATUS } from "../constants";

export function ResultsFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.results);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const isLoading =
    loading.resultsKpis || loading.attempts;

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.results, event, history)
      }
    >
      <Filter.Container>
        <PeriodFilter
          withPeriod
          period={filters.period}
          dateFrom={filters.from}
          dateTo={filters.to}
          options={PERIOD_OPTIONS}
          onPeriodChange={(period) => {
            controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.results, period);
            if (period !== "custom") {
              controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.results, null, history);
            }
          }}
          onDateChange={(field, value) =>
            controller.setDate(CRM_PET_DIAGNOSIS_TABS.results, field, value)
          }
        />
          <Select.Root
            label="Régua"
            value={filters.rule}
            style={CAMPO.medio}
            onChange={(rule) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { rule })
            }
          >
            <Select.Option value="all">Todas</Select.Option>
            {DIAGNOSIS_RULE_OPTIONS.map((option) => (
              <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
            ))}
          </Select.Root>
          {filters.rule === CRM_PET_RULES.ABSENT && (
            <Select.Root
              label="Ausência mínima"
              value={filters.minDays}
              style={CAMPO.medio}
              onChange={(minDays) =>
                controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { minDays })
              }
            >
              <Select.Option value="7">7 dias</Select.Option>
              <Select.Option value="15">15 dias</Select.Option>
              <Select.Option value="30">30 dias</Select.Option>
              <Select.Option value="45">45 dias</Select.Option>
              <Select.Option value="60">60 dias</Select.Option>
              <Select.Option value="90">90 dias</Select.Option>
            </Select.Root>
          )}
          <Select.Root
            label="Contato realizado"
            value={filters.contacted}
            style={CAMPO.medio}
            onChange={(contacted) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { contacted })
            }
          >
            <Select.Option value="all">Todos</Select.Option>
            <Select.Option value="true">Sim</Select.Option>
            <Select.Option value="false">Não</Select.Option>
          </Select.Root>
          <Select.Root
            label="Status"
            value={filters.status}
            style={CAMPO.medio}
            onChange={(status) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { status })
            }
          >
            <Select.Option value="all">Todos</Select.Option>
            {Object.entries(RECOVERY_STATUS).map(([value, option]) => (
              <Select.Option key={value} value={value}>
                {option.label}
              </Select.Option>
            ))}
          </Select.Root>
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={isLoading} />
          Atualizar resultados
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
